import React, { useRef, useState } from 'react';
import { useStoreState } from 'easy-peasy';
import qs from 'querystringify';
import styled from 'styled-components';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import { Label } from 'rbx';

import Layout from '../../../components/global/Layout';
import Header from './Header';
import Search from './Search';
import ListItem from './ListItem';
import {
  Loading,
  Table,
  Box,
  InputAddOn,
  Radio,
} from '../../../components/elements';
import { updateMenuItems, usePlaceMenuItems } from './helpers';
import CheckBox2 from '../../../components/elements/CheckBox2';
import Footer from './Footer';

const ScrollWrapper = styled.div`
  // max-height: 700px;
  // overflow-y: auto;
`;

const StyledTableWrapper = styled.div`
  // table {
  //   width: 100%;
  //   border-collapse: collapse;
  // }

  // thead th {
  //   position: sticky;
  //   top: 0;
  //   z-index: 2;
  //   padding: 10px;
  //   background-color: #f6f6f6;
  // }

  // td {
  //   padding: 10px;
  // }
`;

const Grid1 = styled.div`
  display: grid;
  grid-template-columns: 30px 280px 150px 100px 100px 150px 250px;
  gap: 0;
`;

const getDiscountedPrice = (originalPrice, discountPercentage, operation) => {
  if (!originalPrice || !discountPercentage) {
    return null;
  }
  const discount = (originalPrice * discountPercentage) / 100;
  let discountedPrice = originalPrice - discount;
  if (operation === 'INCREASE') {
    discountedPrice = originalPrice + discount;
  }
  return parseFloat(discountedPrice).toFixed(2);
};

const ApplyPercentageForm = ({
  applyPercentageDiscount,
  recentPercentageDiscount,
  onChange,
}) => {
  const [percentageChange, setPercentageChange] = useState();
  const [applyPercentageChange, setApplyPercentageChange] = useState(false);

  const [operation, setOperation] = React.useState('DECREASE');
  return (
    <Grid1>
      <div className="mt-3 ml-3">
        <CheckBox2
          // label=""
          value={applyPercentageChange}
          onChange={value => {
            onChange('');
            setPercentageChange('');
            setApplyPercentageChange(value);
          }}
        />
      </div>
      <Label className="mt-4">
        <span>Apply percentage changes to all the items</span>
      </Label>
      <div className="mt-1">
        <InputAddOn
          label="Percentage Change"
          addonsText="%"
          isRight
          value={percentageChange}
          onChange={e => {
            if (e.target.value > 99.99) {
              // eslint-disable-next-line no-alert
              alert('The input value must be less than 99.99!');
              return;
            }

            if (e.target.value < 0) {
              // eslint-disable-next-line no-alert
              alert('The input value must be greater than or equal to 0!');
              return;
            }

            setPercentageChange(e.target.value);
            onChange(e.target.value);
          }}
          disableToastMessage
          type="number"
          min="1"
          max="1000"
          disabled={!applyPercentageChange}
        />
      </div>

      <div className="mt-5">
        <Radio
          label="INCREASE"
          value={operation === 'INCREASE'}
          onChange={() => {
            setOperation('INCREASE');
          }}
          disabled={!applyPercentageChange}
        />
      </div>
      <div className="mt-5">
        <Radio
          label="DECREASE"
          value={operation === 'DECREASE'}
          onChange={() => {
            setOperation('DECREASE');
          }}
          disabled={!applyPercentageChange}
        />
      </div>
      <div className="mt-4">
        <button
          type="submit"
          className={`button is-primary `}
          onClick={applyPercentageDiscount(operation)}
          disabled={
            !(
              applyPercentageChange &&
              percentageChange &&
              parseFloat(percentageChange)
            )
          }
        >
          <span>Apply Changes</span>
        </button>
      </div>
      <div className="mt-4">
        <button
          type="submit"
          className={`button is-primary `}
          onClick={() => {
            setOperation('DECREASE');
            setApplyPercentageChange(false);
            setPercentageChange('');
            onChange('');
            recentPercentageDiscount();
          }}
        >
          <span>Reset Changes</span>
        </button>
      </div>
    </Grid1>
  );
};

const BulkItemUpdate = ({ history, match, location }) => {
  const { placename } = match.params;
  const routeState = qs.parse(location.search);
  const { saleType: rSaleType } = routeState;

  const { userId } = useStoreState(state => state.auth);
  const placeName = decodeURIComponent(placename);
  const saleType = rSaleType || 'ITEM';

  const [
    placeMenuItemsLoading,
    placeMenuItems,
    placeMenuItemsData,
    setPlaceMenuItemsData,
    placeMenuItemsLoadingProgress,
  ] = usePlaceMenuItems({
    userId,
    placeName,
    saleType,
  });

  const modifiedItemsRef = useRef(null);

  if (
    !modifiedItemsRef.current &&
    placeMenuItems &&
    placeMenuItems.length !== 0
  ) {
    modifiedItemsRef.current = placeMenuItems;
  }

  const [submitting, setSubmitting] = React.useState(false);
  const [itemName, setItemName] = React.useState('');

  const percentageChangeRef = useRef({ current: '' });

  const handleSubmit = async () => {
    setSubmitting(true);

    try {
      const inputs = Object.values(modifiedItemsRef.current)
        .filter(mItm => mItm.isSelected)
        .map(mItm => {
          const {
            menu_item_id,
            selling_type,
            sell_item_on_its_own,
            price,
            new_price,
            place: { place_id },
            popular_addon,
            popular,
          } = mItm;

          const { variant } = mItm;

          const tempVariant =
            Array.isArray(variant) && variant.length !== 0
              ? variant.map(varnt => {
                  const { prompt, prompt_id, variants } = varnt;

                  let tempVariants = [];

                  if (Array.isArray(variants) && variants.length !== 0) {
                    tempVariants = variants.map(varnts => {
                      const {
                        variant_name,
                        variant_price,
                        variant_id,
                        new_variant_price,
                      } = varnts;
                      return {
                        variant_name,
                        variant_price: new_variant_price || variant_price,
                        variant_id,
                      };
                    });
                  }

                  return { prompt, prompt_id, variants: tempVariants };
                })
              : [];

          const temp = {
            menu_item_id,
            selling_type,
            sell_item_on_its_own,
            place_id,
            user_id: userId,
            price: new_price || price,
            variant: tempVariant,
            popular_addon,
            popular,
          };

          return temp;
        });

      const updateMenuItemsresponse = await updateMenuItems({ input: inputs });

      if (updateMenuItemsresponse.isError) {
        toast.error(updateMenuItemsresponse.error);
      } else {
        swal('Successfully updated items!');
      }
    } catch {
      setSubmitting(false);
    }

    setSubmitting(false);
  };

  const applyPercentageDiscount = operation => () => {
    const percentageValue = parseFloat(percentageChangeRef.current);

    const newPlaceMenuItemsData = [];

    placeMenuItemsData.forEach(mItm => {
      const temp = { ...mItm };
      if (mItm.price) {
        temp.new_price = getDiscountedPrice(
          mItm.price,
          percentageValue,
          operation,
        );
      } else {
        const { variant } = mItm;

        const tempVariant =
          Array.isArray(variant) && variant.length !== 0
            ? variant.map(varnt => {
                const { prompt, prompt_id, variants } = varnt;

                let tempVariants = [];

                if (Array.isArray(variants) && variants.length !== 0) {
                  tempVariants = variants.map(varnts => {
                    const { variant_name, variant_price, variant_id } = varnts;
                    return {
                      variant_name,
                      variant_price,
                      new_variant_price: getDiscountedPrice(
                        variant_price,
                        percentageValue,
                        operation,
                      ),
                      variant_id,
                    };
                  });
                }

                return { prompt, prompt_id, variants: tempVariants };
              })
            : [];
        temp.variant = tempVariant;
      }
      temp.isSelected = true;

      newPlaceMenuItemsData.push(temp);
    });

    const newPlaceMenuItemsDataDict = {};
    newPlaceMenuItemsData.forEach(menuItem => {
      newPlaceMenuItemsDataDict[menuItem.menu_item_id] = menuItem;
    });

    setPlaceMenuItemsData(newPlaceMenuItemsData);

    modifiedItemsRef.current = newPlaceMenuItemsDataDict;
  };

  const recentPercentageDiscount = () => {
    const newPlaceMenuItemsData = [];

    placeMenuItemsData.forEach(mItm => {
      const temp = { ...mItm };
      if (mItm.price) {
        temp.new_price = null;
      } else {
        const { variant } = mItm;

        const tempVariant =
          Array.isArray(variant) && variant.length !== 0
            ? variant.map(varnt => {
                const { prompt, prompt_id, variants } = varnt;

                let tempVariants = [];

                if (Array.isArray(variants) && variants.length !== 0) {
                  tempVariants = variants.map(varnts => {
                    const { variant_name, variant_price, variant_id } = varnts;
                    return {
                      variant_name,
                      variant_price,
                      new_variant_price: null,
                      variant_id,
                    };
                  });
                }

                return { prompt, prompt_id, variants: tempVariants };
              })
            : [];
        temp.variant = tempVariant;
      }
      temp.isSelected = true;

      newPlaceMenuItemsData.push(temp);
    });

    const newPlaceMenuItemsDataDict = {};
    newPlaceMenuItemsData.forEach(menuItem => {
      newPlaceMenuItemsDataDict[menuItem.menu_item_id] = menuItem;
    });

    setPlaceMenuItemsData(newPlaceMenuItemsData);

    modifiedItemsRef.current = newPlaceMenuItemsDataDict;
  };

  const onItemValueChange = ({ itemValue }) => {
    const temp = { ...modifiedItemsRef.current };
    temp[itemValue.menu_item_id] = itemValue;
    modifiedItemsRef.current = temp;
  };

  return (
    <Layout>
      <Header
        history={history}
        isSubmitting={submitting}
        handleSubmit={handleSubmit}
        hideSubmit={
          placeMenuItemsLoading ||
          (placeMenuItemsData && placeMenuItemsData.length === 0) ||
          !placeMenuItemsData
        }
      />
      <Search
        history={history}
        routeState={routeState}
        saleType={saleType}
        placeName={placeName}
        itemName={itemName}
        setItemName={setItemName}
        showFilters={placeMenuItemsData && placeMenuItemsData.length !== 0}
      />
      {placeMenuItemsLoading && (
        <Loading
          label={
            placeMenuItemsLoadingProgress?.totalPages
              ? `Loading page ${placeMenuItemsLoadingProgress.page} of ${placeMenuItemsLoadingProgress.totalPages}`
              : undefined
          }
        />
      )}
      {placeMenuItemsData && placeMenuItemsData.length !== 0 && (
        <>
          <div className="is-flex">
            <div className="m-4 is-flex-grow-1">
              <ApplyPercentageForm
                applyPercentageDiscount={applyPercentageDiscount}
                recentPercentageDiscount={recentPercentageDiscount}
                onChange={value => {
                  percentageChangeRef.current = value;
                }}
              />
            </div>
          </div>
          <Box>
            <View
              key={itemName}
              itemName={itemName}
              placeMenuItemsData={placeMenuItemsData}
              onItemValueChange={onItemValueChange}
            />
          </Box>
          <Footer
            history={history}
            isSubmitting={submitting}
            handleSubmit={handleSubmit}
          />
        </>
      )}
    </Layout>
  );
};

const View = ({ placeMenuItemsData, onItemValueChange, itemName }) => (
  <StyledTableWrapper>
    <ScrollWrapper>
      <Table>
        <thead>
          <tr>
            <th>Item Name</th>
            <th>Price</th>
            <th>New Price</th>
            <th>Popular Item</th>
            <th>Default Add-On</th>
            <th>Selling Type</th>
          </tr>
        </thead>
        <tbody>
          {placeMenuItemsData
            .filter(item => {
              if (itemName && item?.name) {
                const searchTerm = itemName.toLowerCase();
                return item.name.toLowerCase().includes(searchTerm);
              }
              return true;
            })
            .map(item => (
              <ListItem
                item={item}
                key={item.item_id}
                onItemValueChange={onItemValueChange}
              />
            ))}
        </tbody>
      </Table>
    </ScrollWrapper>
  </StyledTableWrapper>
);

export default BulkItemUpdate;
